import { Component, OnInit, signal } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { HeroComponent } from './components/hero/hero.component';
import { AboutComponent } from './components/about/about.component';
import { ServicesComponent } from './components/services/services.component';
import { SkillsComponent } from './components/skills/skills.component';
import { ExperienceComponent } from './components/experience/experience.component';
import { CasesComponent } from './components/cases/cases.component';
import { ProcessComponent } from './components/process/process.component';
import { LocationComponent } from './components/location/location.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { ContactComponent } from './components/contact/contact.component';
import { I18nService } from './services/i18n.service';

@Component({
  selector: 'app-root',
  imports: [
    HeaderComponent,
    HeroComponent,
    AboutComponent,
    ServicesComponent,
    SkillsComponent,
    ExperienceComponent,
    CasesComponent,
    ProcessComponent,
    LocationComponent,
    TestimonialsComponent,
    ContactComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('PortfolioWebsite');

  constructor(private i18nService: I18nService) { }

  ngOnInit(): void {
    this.i18nService.initializeLanguage();
  }
}
